export const ADD = 'ADD'

export const DELETE = 'DELETE'

export const CLEAR = 'CLEAR'